import { Outlet } from "react-router-dom"

export default function LoggedOutLayout(): any {
  return <Outlet />
}
